import React from 'react'

const PrivacyPolicy: React.FC = () => {
  return (
    <div className='text-gray-800 font-sans leading-relaxed'>
      <h1 className='text-3xl font-bold mb-6'>개인정보처리방침</h1>

      <p className='mb-4'>
        큐비(이하 "회사"또는 "qBee")는 개인정보보호법, 통신비밀보호법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호
        등에 관한 법률 등 정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하며, 관련 법령에
        의거한 개인정보처리방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다.
      </p>

      <p className='mb-6'>회사의 개인정보처리방침은 다음과 같습니다.</p>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제 1조. 개인정보의 수집 항목 및 수집 방법
      </h2>

      <h3 className='text-lg font-medium mb-2'>① 수집항목</h3>
      <p className='mb-3'>
        회사는 회원가입, 고객상담, 각종 서비스의 제공을 위해 최초 회원가입 당시 아래와 같은 개인정보를 수집하고
        있습니다.
      </p>
      <ul className='list-disc pl-5 mb-4'>
        <li className='mb-1'>필수 항목 : 이메일, 닉네임, 성별, 생년월일, 학년</li>
        <li className='mb-1'>
          서비스 이용과정이나 사업처리 과정에서 자동으로 생성되어 수집될 수 있는 항목 : IP Address, 쿠키, 방문 일시,
          서비스 이용 기록, 불량 이용 기록, SNS 계정 정보
        </li>
        <li className='mb-1'>
          서비스를 이용하기 위한 결제과정에서 수집되는 항목: 성명, 휴대폰 번호, 신용카드 결제정보(카드사명, 카드 번호
          등), 은행계좌정보 등
        </li>
        <li className='mb-1'>
          부가 서비스 및 맞춤형 개인화 서비스 이용 또는 이벤트 응모 과정에서 해당 서비스의 이용자에 한해 수집될 수 있는
          항목 : 이동전화번호, 통신사, 주소, 기타 물품수령에 필요한 개인정보
        </li>
        <li className='mb-1'>선택 : 이용자의 선택에 따라 본인의 SNS 계정 등을 연결하기 위한 계정 정보, 학교, MBTI</li>
      </ul>

      <h3 className='text-lg font-medium mb-2'>② 개인정보 수집 방법</h3>
      <ul className='list-disc pl-5 mb-4'>
        <li className='mb-1'>서비스 이용 신청 과정에서 수집</li>
        <li className='mb-1'>팩스, 전화, 상담, 이메일, 이벤트 응모 등의 과정에서 수집</li>
        <li className='mb-1'>협력회사로부터의 정보 수집 툴을 통한 수집</li>
      </ul>

      <h3 className='text-lg font-medium mb-2'>③ 민감정보 수집</h3>
      <p className='mb-3'>
        서비스의 특성상 상담과정에서 개인의 건강과 관련된 정보가 수집되며, 상담 내용과 진행에 따라 추가적인 개인정보가
        포함될 수 있습니다.
      </p>
      <p className='mb-3'>
        <span className='font-bold'>상담 과정에서 수집되는 개인정보에는 민감정보가 포함</span>될 수 있습니다.
      </p>
      <ul className='list-disc pl-5 mb-6'>
        <li className='mb-1'>상담경험, 정신과 진료경험, 신체적/정신적 호소 문제, 성장 과정등의 개인적인 문제</li>
      </ul>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제 2조. 개인정보 수집 및 이용 목적
      </h2>
      <p className='mb-4'>
        회사는 회원관리(회원 가입 의사 확인, 본인확인, 개인식별, 회원탈퇴 의사 확인 등), 회사 서비스 제공, 서비스 개발
        및 개선, 안전한 인터넷 이용환경 구축 등 아래의 목적으로만 개인정보를 이용합니다.
      </p>

      <h3 className='text-lg font-medium mb-2'>① 회사 서비스 제공</h3>
      <p className='mb-3'>
        서비스 이용요금 결제, 콘텐츠 제공, 상담 서비스 제공, 이메일 인증, 물품배송 또는 청구서 등 발송
      </p>

      <h3 className='text-lg font-medium mb-2'>② 회원관리</h3>
      <p className='mb-3'>
        회원제 서비스 이용, 본인확인, 개인식별, 서비스 이용요금 결제와 상담 등 서비스 이용 과정에서 법령 및 회사
        이용약관을 위반하는 회원에 대한 이용 제한 조치, 부정 이용방지와 비인가 사용방지, 가입의사 확인, 추후 법정 대리인
        본인확인, 분쟁 조정을 위한 기록보존, 불만처리 등 민원처리, 고지사항 전달
      </p>

      <h3 className='text-lg font-medium mb-2'>③ 신규 서비스 개발 및 마케팅</h3>
      <p className='mb-3'>
        신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인,
        이벤트 및 광고성 정보 제공 및 참여기회 제공, 회원의 서비스 이용에 대한 통계, 접속빈도 파악, 심리 상담 관련
        통계나 연구 등을 통해 심리상담 솔루션 개발 및 개선
      </p>

      <h3 className='text-lg font-medium mb-2'>④ 맞춤형 개인화 서비스 개발</h3>
      <p className='mb-6'>개인정보 및 상담에 기반한 맞춤형 추천 알고리즘 등의 서비스 개발 및 개선</p>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제 3조. 개인정보 공유 및 제공
      </h2>
      <h3 className='text-lg font-medium mb-2'>① 개인정보 제공 원칙</h3>
      <p className='mb-3'>
        회사는 이용자들의 개인정보를 <span className='font-bold'>"제 2조 개인정보 수집 및 이용 목적"</span> 에서 고지한
        범위 내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를
        외부에 공개하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
      </p>
      <ul className='list-disc pl-5 mb-4'>
        <li className='mb-1'>이용자가 외부 제휴사의 서비스를 이용하기 위하여 개인정보 제공에 동의를 한 경우</li>
        <li className='mb-1'>
          법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관 또는 정보기관 등의 요구가
          있는 경우
        </li>
        <li className='mb-1'>이용자의 생명이나 안전에 급박한 위험이 확인되어 이를 해소하기 위한 경우</li>
      </ul>

      <h3 className='text-lg font-medium mb-2'>② 세금 관련 정보 제공</h3>
      <p className='mb-6'>
        기타 세금과 관련하여 부가가치세 징수 목적 또는 연말정산 등을 위해 관계법령에 따라 개인정보가 국세청 또는 관세청
        등 과세 관련 처분청에 제공될 수 있습니다.
      </p>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제 4조. 개인정보의 처리 위탁
      </h2>
      <h3 className='text-lg font-medium mb-2'>① 위탁 가능성</h3>
      <p className='mb-3'>회사는 편리하고 더 나은 서비스를 제공하기 위해 업무 중 일부를 외부에 위탁할 수 있습니다.</p>

      <h3 className='text-lg font-medium mb-2'>② 위탁 시 관리</h3>
      <p className='mb-6'>
        회사는 서비스 제공을 위하여 필요한 업무중 일부를 외부 업체에 위탁할 수 있으며, 위탁할 경우 위탁 받은 업체가
        정보통신망법에 따라 개인정보를 안전하게 처리하도록 필요한 사항을 규정하고 관리/감독을 합니다.
      </p>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제 5조. 개인정보 보유 및 이용 기간
      </h2>
      <p className='mb-6'>
        원칙적으로 이용자가 서비스에 가입한 날로부터 계정 삭제 또는 해지 시까지 개인정보를 보유 및 이용합니다. 회원 탈퇴
        시 회사는 이용자의 수집된 개인정보가 열람 또는 이용될 수 없도록 파기 처리합니다. 단, 관계법령의 규정에 의하여
        보존할 필요가 있는 경우, 회사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다.
      </p>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제 6조. 개인정보 파기 절차 및 방법
      </h2>
      <h3 className='text-lg font-medium mb-2'>① 파기 원칙</h3>
      <p className='mb-3'>
        회사는 원칙적으로 이용자가 회원 탈퇴 시 회사는 특정 보호 기간을 거쳐 이용자의 수집된 개인정보가 열람 또는 이용될
        수 없도록 파기 처리합니다. 단, 이용자에게 개인정보 보관기간에 대해 별도의 동의를 얻은 경우, 또는 법령에서 일정
        기간 정보 보관 의무를 부과하는 경우에는 해당 기간 동안 개인정보를 안전하게 보관합니다.
      </p>

      <h3 className='text-lg font-medium mb-2'>② 파기 절차 및 방법</h3>
      <p className='mb-3'>개인정보 파기의 절차 및 방법은 다음과 같습니다.</p>
      <ul className='list-disc pl-5 mb-6'>
        <li className='mb-1'>
          <span className='font-bold'>파기 절차</span> : 이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져 (종이의
          경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로
          옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다
        </li>
        <li className='mb-1'>
          <span className='font-bold'>파기 방법</span> : 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여
          파기합니다. 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적인 방법을 사용하여 삭제합니다.
        </li>
      </ul>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제 7조. 개인정보의 수집/이용/제공 동의 철회
      </h2>
      <p className='mb-6'>
        이용자가 회원가입 등을 통해 개인정보의 수집/이용/제공에 대해 동의하신 내용을 언제든지 철회할 수 있습니다. 동의
        철회는 관리 책임자에게
        <span className='font-bold'>전자적 통신수단(E-mail 등) 및 앱 상의 기능 등을 이용하여 신청</span>할 수 있으며,
        회사는 이를 확인 후 회원 탈퇴를 위해 필요한 조치를 취합니다.
      </p>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제 8조. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항
      </h2>
      <h3 className='text-lg font-medium mb-2'>① 쿠키 사용</h3>
      <p className='mb-3'>
        회사는 이용자들에게 특화된 맞춤서비스를 제공하기 위해서 이용자들의 정보를 저장하고 수시로 불러오는
        <span className='font-bold'>쿠키(cookie)</span>를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버(HTTP)가
        이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터 내의 하드디스크에 저장되기도 합니다.
      </p>

      <h3 className='text-lg font-medium mb-2'>② 쿠키 사용 목적</h3>
      <p className='mb-3'>
        쿠키는 이용자들이 방문한 AI매니저의 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부,
        뉴스편집, 이용자 규모 등을 파악하여 이용자에게 <span className='font-bold'>최적화된 정보 제공</span>을 위하여
        사용합니다.
      </p>

      <h3 className='text-lg font-medium mb-2'>③ 쿠키 설치 선택권</h3>
      <p className='mb-3'>
        이용자는 <span className='font-bold'>쿠키 설치에 대한 선택권</span>을 가지고 있습니다. 따라서, 이용자는
        웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든
        쿠키의 저장을 거부할 수도 있습니다.
      </p>

      <h3 className='text-lg font-medium mb-2'>④ 쿠키 설정 방법</h3>
      <p className='mb-3'>
        쿠키 설정을 거부하는 방법으로는 이용자가 사용하는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나
        쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.
      </p>
      <ul className='list-disc pl-5 mb-3'>
        <li className='mb-1'>
          설정방법 예(인터넷 익스플로어의 경우) : 웹 브라우저 상단의 도구 {'>'} 인터넷 옵션 {'>'} 개인정보
        </li>
      </ul>
      <p className='mb-6'>
        다만, 쿠키의 저장을 거부할 경우 로그인이 필요한 일부 서비스는 이용에 어려움이 있을 수 있습니다.
      </p>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제 9조. 개인정보보호를 위한 기술적/관리적 대책
      </h2>
      <p className='mb-4'>
        회사는 이용자의 개인정보를 보호하기 위해 기술적 대책과 관리적 대책을 마련하고 있으며, 이를 적용하고 있습니다.
      </p>

      <h3 className='text-lg font-medium mb-2'>① 개인정보 암호화</h3>
      <p className='mb-3'>
        회사의 회원 아이디(ID)의 비밀번호는 암호화되어 저장 및 관리되고 있어 본인만이 알고 있으며, 개인정보의 확인 및
        변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다.
      </p>

      <h3 className='text-lg font-medium mb-2'>② 해킹 등에 대비한 대책</h3>
      <p className='mb-3'>
        회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고
        있습니다. 개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의
        개인정보나 자료가 누출되거나 손상되지 않도록 방지하고 있으며, 암호화통신 등을 통하여 네트워크상에서 개인정보를
        안전하게 전송할 수 있도록 하고 있습니다. 그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고
        있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.
      </p>

      <h3 className='text-lg font-medium mb-2'>③ 취급 직원의 최소화 및 교육</h3>
      <p className='mb-3'>
        회사의 개인정보관련 취급 직원은 담당자에 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로
        갱신하고 있으며, 담당자에 대한 수시 교육을 통하여 회사의 개인정보처리방침의 준수를 항상 강조하고 있습니다.
      </p>

      <h3 className='text-lg font-medium mb-2'>④ 개인정보보호전담기구의 운영</h3>
      <p className='mb-6'>
        사내 개인정보보호전담기구 등을 통하여 회사의 개인정보처리방침 이행사항 및 담당자의 준수여부를 확인하여 문제가
        발견될 경우 즉시 수정하고 바로 잡을 수 있도록 노력하고 있습니다.
      </p>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제 10조. 이용자의 권리
      </h2>
      <p className='mb-6'>
        이용자는 언제든지 본 서비스에 등록되어 있는 본인의 개인정보를 열람하거나 정정할 수 있으며, 전자우편 또는 앱 상의
        기능을 이용하여 요청하신 경우 열람, 정정, 삭제처리 해드리겠습니다.
      </p>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제 11조. 개인 정보 관련 담당자 연락처
      </h2>
      <p className='mb-4'>
        귀하께서는 회사의 서비스를 이용하시면서 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은
        담당부서로 신고하실 수 있습니다. 회사는 회원의 신고사항에 대해 신속하게 답변을 드릴 것입니다.
      </p>

      <div className='bg-gray-50 p-3 rounded-md my-2 overflow-x-auto'>
        <table className='w-full border-collapse'>
          <thead>
            <tr>
              <th className='border border-gray-300 py-1.5 px-2 text-left bg-gray-100 w-20 text-xs'>구분</th>
              <th className='border border-gray-300 py-1.5 px-3 text-left bg-gray-100 text-xs'>개인정보보호책임자</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className='border border-gray-300 py-1 px-2 text-left font-medium text-xs'>이름</td>
              <td className='border border-gray-300 py-1 px-3 text-left text-xs'>고승재</td>
            </tr>
            <tr>
              <td className='border border-gray-300 py-1 px-2 text-left font-medium text-xs'>소속</td>
              <td className='border border-gray-300 py-1 px-3 text-left text-xs'>넥스큐브코퍼레이션</td>
            </tr>
            <tr>
              <td className='border border-gray-300 py-1 px-2 text-left font-medium text-xs'>전화</td>
              <td className='border border-gray-300 py-1 px-3 text-left text-xs'>070-8676-8793</td>
            </tr>
            <tr>
              <td className='border border-gray-300 py-1 px-2 text-left font-medium text-xs'>이메일</td>
              <td className='border border-gray-300 py-1 px-3 text-left text-xs'>it_support@nexcubecorp.com</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p className='mb-4'>기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.</p>
      <ol className='list-decimal mb-6 pl-6'>
        <li className='mb-2'>
          개인정보침해신고센터 (
          <a href='http://www.118.or.kr' className='text-blue-600 hover:underline'>
            http://www.118.or.kr
          </a>{' '}
          / 국번없이 118)
        </li>
        <li className='mb-2'>
          대검찰청 사이버 범죄 수사단 (
          <a href='http://www.spo.go.kr' className='text-blue-600 hover:underline'>
            http://www.spo.go.kr
          </a>{' '}
          / 02-3480-2000)
        </li>
        <li className='mb-2'>
          경찰청 사이버테러대응센터 (
          <a href='http://www.ctrc.go.kr' className='text-blue-600 hover:underline'>
            http://www.ctrc.go.kr
          </a>{' '}
          / 1566-0112)
        </li>
      </ol>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>제 12조. 기타</h2>
      <p className='mb-6'>
        회사에 링크되어 있는 웹사이트들이 개인정보를 수집하는 행위에 대해서는 본 "회사 개인정보처리방침"이 적용되지
        않음을 알려 드립니다.
      </p>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제 13조. 고지의 의무
      </h2>
      <p className='mb-6'>
        현 "회사 개인정보처리방침"에 내용이 추가되거나 삭제 및 수정이 있을 시 개정
        <span className='font-bold'>최소 7일</span>전부터 홈페이지의 '공지사항' 및 다양한 방법으로 고지할 것입니다. 단,
        개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는
        <span className='font-bold'>최소 30일</span>전에 고지합니다.
      </p>

      <p className='text-center mt-10 font-bold'>공고일자 : 2025.06.28</p>
    </div>
  )
}

export default PrivacyPolicy
